import { render, staticRenderFns } from "./BreadcrumbBase.vue?vue&type=template&id=00a23aee&scoped=true&"
import script from "./BreadcrumbBase.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a23aee",
  null
  
)

export default component.exports